import { Pipe, PipeTransform } from '@angular/core';
import * as stringUtils from 'string';

@Pipe({
  name: 'str'
})
export class StrPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let str = stringUtils(value);

    args.forEach((method: string) => {
      str = str[method].call(str);
    });

    return str.toString();
  }
}
